export const addResultHalCompass = (resultHalCompass) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    if (
      !resultHalCompass.companyProfile ||
      !resultHalCompass.dateCreated ||
      !resultHalCompass.selectedAnswers ||
      !resultHalCompass.selectedScheme ||
      !resultHalCompass.userId ||
      resultHalCompass.pdpaConsent == null ||
      !resultHalCompass.selectedSchemeScope
    ) {
      dispatch({
        type: "ADDED_RESULT_HALCOMPASS_ERROR",
        err: { message: "Input field required." },
      });
    } else {
      let id = resultHalCompass.companyProfile.companyId;
      let totalScore = 0;
      let percentageScore = 0;
      let maxScore = 0;
      let selectedRank;

      const twoWeeksFromNow = new Date();
      twoWeeksFromNow.setDate(twoWeeksFromNow.getDate() + 14);
      const expiredDate = twoWeeksFromNow.toISOString().split("T")[0];

      if (resultHalCompass.isNewCompany) {
        id = await firestore
          .collection("companyProfile")
          .add({
            name: resultHalCompass.companyProfile.name,
            halalNeeds: resultHalCompass.companyProfile.halalNeeds,
            industrialCategory:
              resultHalCompass.companyProfile.industrialCategory,
            operationalHour: resultHalCompass.companyProfile.operationalHour,
            phoneNumber: resultHalCompass.companyProfile.phoneNumber,
            shift: resultHalCompass.companyProfile.shift,
            staffTotal: resultHalCompass.companyProfile.staffTotal,
            userId: resultHalCompass.userId,
            website: resultHalCompass.companyProfile.website,
          })
          .then((resp) => {
            resultHalCompass.companyProfile.companyId = resp.id;
            return resp.id;
          });
      } else {
        firestore.collection("companyProfile").doc(id).update({
          halalNeeds: resultHalCompass.companyProfile.halalNeeds,
          industrialCategory:
            resultHalCompass.companyProfile.industrialCategory,
          operationalHour: resultHalCompass.companyProfile.operationalHour,
          phoneNumber: resultHalCompass.companyProfile.phoneNumber,
          shift: resultHalCompass.companyProfile.shift,
          staffTotal: resultHalCompass.companyProfile.staffTotal,
          userId: resultHalCompass.userId,
          website: resultHalCompass.companyProfile.website,
        });
      }

      const ranking = await firestore
        .collection("ranking")
        .where(
          "selectedSchemes",
          "array-contains",
          resultHalCompass.selectedScheme
        )
        .orderBy("minPercentage")
        .get()
        .then((resp) => {
          return resp.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        });

      const user = await firestore
        .collection("users")
        .where("userId", "==", resultHalCompass.userId)
        .get()
        .then((resp) => {
          return resp.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        });

      const selectedAnswers = resultHalCompass.selectedAnswers.map((doc) => {
        let totalCriteriaScore = 0;
        const maxCriteriaScore = doc.answers.length * 3;

        doc.answers.forEach((answer) => {
          totalCriteriaScore = totalCriteriaScore + answer.score;
        });

        let percentageCreteriaScore = Math.round(
          (totalCriteriaScore / maxCriteriaScore) * 100
        );

        return {
          ...doc,
          totalCriteriaScore,
          maxCriteriaScore,
          percentageCreteriaScore,
        };
      });

      selectedAnswers.forEach((doc) => {
        totalScore = totalScore + doc.totalCriteriaScore;
        maxScore = maxScore + doc.maxCriteriaScore;
      });

      percentageScore = Math.round((totalScore / maxScore) * 100);

      ranking.forEach((doc) => {
        const tempRank = doc;

        if (
          percentageScore >= tempRank.minPercentage &&
          percentageScore <= tempRank.maxPercentage
        ) {
          selectedRank = tempRank;
        }
      });

      firestore
        .collection("resultHalCompass")
        .add({
          companyProfile: resultHalCompass.companyProfile,
          dateCreated: resultHalCompass.dateCreated,
          selectedScheme: resultHalCompass.selectedScheme,
          selectedAnswers: selectedAnswers,
          percentageScore: percentageScore,
          rankings: ranking,
          selectedRanking: selectedRank,
          totalScore: totalScore,
          userId: resultHalCompass.userId,
          status:"active",
          pdpaConsent: resultHalCompass.pdpaConsent,
          dateExpired: expiredDate,
          userFirstname:user[0].firstname,
          userLastname:user[0].lastname,
          userFullName:user[0]?.fullname ?? "",
          selectedSchemeScope: resultHalCompass.selectedSchemeScope
        })
        .then((resp) => {
          dispatch({
            type: "ADDED_RESULT_HALCOMPASS",
            message: "Result HalCompass added successfully.",
            id: resp.id,
          });
        })
        .catch((err) => {
          dispatch({ type: "ADDED_RESULT_HALCOMPASS_ERROR", err });
        });
    }
  };
};
